import React from 'react';
import { CheckIcon, HammerIcon, HardHatIcon } from 'lucide-react';
import { GUESSWORK } from '../../data/catio';
const PATHS = [{
  icon: HammerIcon,
  label: 'Start from an existing design'
}, {
  icon: HardHatIcon,
  label: 'Verify every site before you build'
}];

/** Professional starting point + pre-build review checklist. */
export function ObjectionSection() {
  return <section aria-labelledby="diy-title" className="bg-ivory py-12 sm:py-20" data-id="element-199" data-mp="32auym6xh0ao2">
      <div className="mx-auto grid w-full max-w-6xl gap-10 px-5 sm:px-8 lg:grid-cols-2 lg:gap-16" data-id="element-200" data-mp="328qqtdwgarii">
        <div data-id="element-201" data-mp="36ac4v2kq1bua">
          <h2 id="diy-title" className="font-display text-[1.85rem] leading-[1.12] text-ink sm:text-[2.6rem]" data-id="element-202" data-mp="2scnly0a7serv">
            A Design Starting Point for Your Next Client Build
          </h2>
          <p className="mt-4 text-[1rem] leading-relaxed text-graphite sm:text-[1.05rem]" data-id="element-203" data-mp="1gx8rb35h9yzx">
            Choose a suitable design, check the actual site and verify any required adaptations
            before construction. The collection supports planning; each build still requires your
            professional judgment.
          </p>

          <div className="mt-6 grid gap-2" data-id="element-204" data-mp="1ix8hiue2oyzg">
            {PATHS.map(path => {
            const Icon = path.icon;
            return <p key={path.label} className="flex items-center gap-4 rounded-[14px] border border-line bg-paper px-5 py-4" data-id="element-205" data-mp="1rwlrrpa0trl8">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-wood-light text-wood" data-id="element-206" data-mp="25tqtjd2pc4ao">
                    <Icon className="h-5 w-5" strokeWidth={1.8} aria-hidden data-id="element-207" data-mp="2fm6codpqiyx5" />
                  </span>
                  <span className="font-display text-[1.3rem] leading-tight text-ink" data-id="element-208" data-mp="2amk0m7ln7opx">
                    {path.label}
                  </span>
                </p>;
          })}
          </div>
        </div>

        <div className="lg:pt-2" data-id="element-209" data-mp="2kmase1itjpmb">
          <h3 className="font-display text-[1.6rem] leading-[1.15] text-ink sm:text-[2rem]" data-id="element-210" data-mp="2kj6hymerfxn7">
            Review the Details Before You Buy or Cut
          </h3>
          <ul className="mt-5 grid border-t border-line sm:grid-cols-2 sm:gap-x-4" data-id="element-211" data-mp="2wo2gh5801hqi">
            {GUESSWORK.map(item => <li key={item} className="flex items-center gap-2.5 border-b border-line py-3.5 text-[0.95rem] leading-snug text-graphite" data-id="element-212" data-mp="31kaozzroycop">
                <CheckIcon className="h-4 w-4 shrink-0 text-ember" strokeWidth={2.25} aria-hidden data-id="element-213" data-mp="3bbnjz08sdiyy" />
                {item}
              </li>)}
          </ul>
          <p className="mt-5 text-[1.05rem] font-semibold text-ink" data-id="element-214" data-mp="3kclk37g3t6c9">
            A clear plan removes unnecessary guesswork.
          </p>
        </div>
      </div>
    </section>;
}